export function canEditManagementAllotmentDraft(options: {
  isDraft: boolean
  hasEditPermission: boolean
  isOfficeUser: boolean
  hasManagementPermission: boolean
  canManageAllotmentDraft?: boolean
}): boolean {
  return options.isDraft && options.hasEditPermission && options.isOfficeUser
    && options.hasManagementPermission && options.canManageAllotmentDraft === true
}

export function canSubmitAllotmentDraft(options: {
  isDraft: boolean
  hasSubmitPermission: boolean
  isRecordOwner: boolean
  isOfficeUser: boolean
  recordId: number
  hasManagementPermission: boolean
  canManageAllotmentDraft?: boolean
}): boolean {
  if (!options.isDraft) return false
  return (options.isRecordOwner && options.hasSubmitPermission) || (
    options.isOfficeUser && options.recordId > 0 && options.hasManagementPermission
      && options.canManageAllotmentDraft === true
  )
}
